import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { t } from "i18next";
import { useState } from "react";
import { FaArrowRight, FaFileContract } from "react-icons/fa";
import { To, useNavigate } from "react-router-dom";
import { BseDto, ContractDto, ContractStateDto, ReceivedBseBidDto, useGetContractQuery } from "../../../../autogen/bff-api";
import { urls } from "../../../../urls";
import { CreateContractModal } from "./CreateContractModal";

export const CreateContractDetail = ({ bid, sourcingEvent }: { bid: ReceivedBseBidDto; sourcingEvent: BseDto }) => {
  const navigate = useNavigate();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const contractId = bid.contractId;
  const { data: contract, isFetching } = useGetContractQuery(contractId ? { contractId } : skipToken);

  const goToContract = (id: string) => navigate(contractDestination(id, sourcingEvent.id, contract));

  return (
    <Flex key={bid.id} alignItems={"center"} py="4">
      <Text fontWeight={"semibold"} pr="4">
        {bid.owningOrganization.name}
      </Text>
      {contractId ? (
        <Button
          colorScheme="teal"
          variant={"ghost"}
          rightIcon={<Icon as={FaArrowRight} />}
          isLoading={isFetching}
          onClick={() => goToContract(contractId)}
        >
          {t("Go to contract")}
        </Button>
      ) : sourcingEvent.canCreateContract ? (
        <>
          <Button
            size="sm"
            variant={"outline"}
            colorScheme="teal"
            leftIcon={<Icon as={FaFileContract} />}
            onClick={() => setShowCreateModal(true)}
          >
            {t("Create contract")}
          </Button>
          {showCreateModal && (
            <CreateContractModal onClose={() => setShowCreateModal(false)} sourcingEvent={sourcingEvent} bid={bid} />
          )}
        </>
      ) : null}
    </Flex>
  );
};

export const contractDestination = (contractId: string, sourcingEventId: string, contract: ContractDto | undefined): To =>
  contract && contract.state !== ContractStateDto.Published
    ? urls.contracts.edit.go(contractId, sourcingEventId).review
    : urls.contracts.viewSingle.go(contractId);
